import { render } from "./ImportPaymentRequestsModal.vue?vue&type=template&id=081b8284&scoped=true&ts=true"
import script from "./ImportPaymentRequestsModal.vue?vue&type=script&lang=ts"
export * from "./ImportPaymentRequestsModal.vue?vue&type=script&lang=ts"

import "./ImportPaymentRequestsModal.vue?vue&type=style&index=0&id=081b8284&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081b8284"]])

export default __exports__